// extracted by mini-css-extract-plugin
export default {"redBlob":"Tag_redBlob__+LLyo","blueBlob":"Tag_blueBlob__7wRu-","yellowBlob":"Tag_yellowBlob__XqLas","greenBlob":"Tag_greenBlob__tENLU","container":"Tag_container__WeRN0"};